//namespace Pacem.Compile {
class LexerClass {
    tokenize(input, grammar) {
        const tokens = [];
        while (input) {
            const start = input.length;
            for (let rule of grammar) {
                const newTokens = rule.exec(input, /* arguments that ease recursion when needed */ this), length = newTokens?.length;
                if (length > 0) {
                    Array.prototype.push.apply(tokens, newTokens);
                    const last = newTokens[length - 1];
                    input = input.substr((last.index || 0) + last.raw.length);
                    break;
                }
            }
            if (input.length >= start) {
                // break infinite loop
                throw new Error(`Cannot parse\n"${input}"\n using the provided grammar.`);
            }
        }
        return tokens;
    }
}
export class Parser {
    constructor(_lexer = new LexerClass()) {
        this._lexer = _lexer;
    }
    parse(input, grammar, renderer) {
        const tokens = this._lexer.tokenize(input, grammar);
        return renderer.render(tokens);
    }
}
//}
